export function SpotifyEmbed({
  spotifyTrackId,
  className,
}: {
  spotifyTrackId: string;
  className?: string;
}) {
  const spotifyEmbedCode = {
    __html: `<iframe style="border-radius:12px" src="https://open.spotify.com/embed/track/${spotifyTrackId}?utm_source=generator&theme=0" width="100%" height="80" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>`,
  };

  return (
    <div dangerouslySetInnerHTML={spotifyEmbedCode} className={className} />
  );
}
